
import BundleProduct from "./BundleProduct";

export default {
  components: { BundleProduct },

  props: { slice: { type: Object, required: true } },
};
